import React, { memo } from "react";
import useStyles from "../Modal/styles";
import { Box} from "@material-ui/core";
import ObjectivesList from "Modules/Dashboard/Objectives/ObjectivesList";
// TODO: can be deleted
const ObjectiveWidgetsListBody = ({
  objectives,
  objectiveDetail,
  targetId
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.ObjectiveListModal}>
      <ObjectivesList
        objectives={objectives}
        targetId={targetId}
        targetDetail={objectiveDetail}
      />
    </Box>
  );
};

export default memo(ObjectiveWidgetsListBody);
